import { GetterTree, MutationTree, ActionTree } from 'vuex'
import * as T from '@/types'

import api from '@/api'
import crud from '@/store/store-crud'

import { mixin } from '@/store/utils'

const INITIAL_STATE: () => Partial<T.Store.SourcesState> = () => ({

})

const getters: GetterTree<T.Store.SourcesState, T.Store.RootState> = {
}

const mutations: MutationTree<T.Store.SourcesState> = {
}

const actions: ActionTree<T.Store.SourcesState, T.Store.RootState> = {
}

const module = (mixin<T.Store.SourcesState, T.Store.RootState>())(
    [crud<T.Source>(api.sources)],
    {
        namespaced: true,
        state: INITIAL_STATE(),
        actions,
        getters,
        mutations,
    },
)

export default module
